import React from 'react'
import { useLocation } from 'react-router'
import {
    ContentDataDefinitionLoader,
    createRegisterableComponentWithData,
} from '@news-mono/web-common'

import { CollectionRouteProps } from '../collections'
import { calculateExpectedCardCountFromContentData } from '../collections/collections-props.routing'
import { LoadMoreRouteProps } from '../data-controllers/LoadMore/LoadMore'
import { ResponsiveContainer } from '../content/Picture/responsive'

import { ThemeMargins } from '../__styling'

import { mapTopVideoMeta } from '../VideoHub/helpers/mapToVideoMeta'
import { VerticalVideoHub } from './VerticalVideoHub'
import { StyledVerticalVideoHub } from './VerticalVideoHub.styled'
import { VerticalVideoCarousel } from './VerticalVideoCarousel'

export interface VerticalVideoHubRouteProps
    extends CollectionRouteProps,
        LoadMoreRouteProps,
        ResponsiveContainer {
    adUnitPath: string
    showAds?: boolean
    verticalGutters?: [keyof ThemeMargins, keyof ThemeMargins]
    verticalSpacing?: keyof ThemeMargins
    lazyLoad?: boolean
}

export const VerticalVideoHubRegistration = createRegisterableComponentWithData(
    'vertical-video-hub',
    ContentDataDefinitionLoader,
    (props: VerticalVideoHubRouteProps, data, services) => {
        const location = useLocation()
        if (!data.loaded) {
            const skeletonCount = data.dataDefinitionArgs
                ? calculateExpectedCardCountFromContentData(
                      data.dataDefinitionArgs,
                  )
                : 5

            return (
                <StyledVerticalVideoHub
                    verticalGutters={props.verticalGutters}
                    verticalSpacing={props.verticalSpacing}
                >
                    <VerticalVideoCarousel
                        videos={[]}
                        cardItems={[]}
                        onSelect={() => {}}
                        isLoading={true}
                        skeletonCount={skeletonCount}
                    />
                </StyledVerticalVideoHub>
            )
        }

        const videoList = mapTopVideoMeta(data.result.publications)

        return (
            <VerticalVideoHub
                videos={videoList}
                onEvent={services.onEvent}
                adUnitPath={props.adUnitPath}
                showAds={props.showAds}
                currentPath={location.pathname}
                publicUrl={services.config.publicUrl}
                verticalGutters={props.verticalGutters}
                verticalSpacing={props.verticalSpacing}
                lazyLoad={props.lazyLoad}
                loadMoreDataDefinition={data.dataDefinitionArgs}
                loadMoreInitialData={data}
                loadMoreServices={services}
            />
        )
    },
)
